export function setNews(newsLength, spLength, isTopMode) {
    if (!spLength) {
        spLength = newsLength;
    }

    if (isTopMode) {
        document.body.classList.add("-news_topmode");
    }

    const newswrapper = document.querySelector(".js-news_wrapper");
    const newslist = document.querySelector(".c-news__list");
    const newsItems = [...newslist.querySelectorAll(".c-news__list__item")];

    //初期化
    newswrapper.innerHTML = "";

    //NEWSがnewsLength個以下のとき
    if (newsItems.length < newsLength) {
        while (newsItems.length < newsLength) {
            const spacer = document.createElement("li");
            spacer.classList.add("c-news__list__item", "-spacer");
            newsItems.push(spacer);
        }
    }

    //SPで隠す要素を設定
    newsItems.forEach((el, index) => index > spLength - 1 && el.classList.add("c-visible_wide"));

    //3+2のグループ　SPでは1+2 or 2 + 1
    const listlength = window.innerWidth <= 835 ? Math.ceil(newsItems.length / 3) : Math.ceil(newsItems.length / 5);

    for (let i = 0; i < listlength; i++) {
        for (let k = 0; k <= 1; k++) {
            if (k == 0) {
                const listdom = document.createElement("ul");
                listdom.classList.add("c-news__list", "js-newsscrollreveal");

                if (window.innerWidth <= 835) {
                    const row = 3 * i;
                    newsItems[row] && listdom.appendChild(newsItems[row]);

                    if (isTopMode) {
                        newsItems[row + 1] && listdom.appendChild(newsItems[row + 1]);
                    }
                } else {
                    const row = 3 * i + 2 * i;
                    newsItems[row] && listdom.appendChild(newsItems[row]);
                    newsItems[row + 1] && listdom.appendChild(newsItems[row + 1]);
                    newsItems[row + 2] && listdom.appendChild(newsItems[row + 2]);
                }

                newswrapper.appendChild(listdom);
            } else if (k == 1) {
                let children = 0;
                const listdom = document.createElement("ul");
                listdom.classList.add("c-news__list", "js-newsscrollreveal");

                if (window.innerWidth <= 835) {
                    const row = isTopMode ? 3 * i + 2 : 3 * i + 1;

                    //2段目が存在しないパターンもあるので子要素を数える
                    if (newsItems[row]) {
                        listdom.appendChild(newsItems[row]);
                        children++;
                    }

                    if (!isTopMode) {
                        if (newsItems[row + 1]) {
                            listdom.appendChild(newsItems[row + 1]);
                            children++;
                        }
                    }
                } else {
                    const row = 3 * (i + 1) + 2 * i;

                    //2段目が存在しないパターンもあるので子要素を数える
                    if (newsItems[row]) {
                        listdom.appendChild(newsItems[row]);
                        children++;
                    }

                    if (newsItems[row + 1]) {
                        listdom.appendChild(newsItems[row + 1]);
                        children++;
                    }
                }

                if (children > 0) {
                    newswrapper.appendChild(listdom);
                }
            }
        }
    }
}
